import s from "./style.module.css";
import cn from "classnames";
import fixRelativeLinks from "../../helpers/fixRelativeLinks";

export const Text = ({ children }) => (
  <p className={s.text} dangerouslySetInnerHTML={{ __html: children }} />
);

export const Heading = ({ children, tag: Tag = "h2", className, ...rest }) => (
  <Tag
    className={cn(s.heading, { [className]: className })}
    dangerouslySetInnerHTML={{ __html: children }}
    {...rest}
  />
);

export const SubHeading = ({ children, className, ...rest }) => (
  <h3
    className={cn(s.subHeading, { [className]: className })}
    dangerouslySetInnerHTML={{ __html: children }}
    {...rest}
  />
);

export const Standfirst = ({ children, className, ...rest }) => (
  <p
    className={cn(s.standfirst, { [className]: className })}
    dangerouslySetInnerHTML={{ __html: children }}
    {...rest}
  />
);

export const Image = ({ src, alt, caption }) => (
  <figure className={s.imageWrap}>
    <img className={s.image} src={`/${src}`} alt={alt} />
    {caption && <figcaption className={s.caption}>{caption}</figcaption>}
  </figure>
);

export const Figure = ({
  src,
  alt,
  caption,
  title,
  intro,
  source,
  note,
  list,
}) => (
  <figure className={s.figure}>
    {caption && (
      <figcaption
        className={s.figureCaption}
        dangerouslySetInnerHTML={{ __html: caption }}
      />
    )}
    {title && <Heading tag={"h3"}>{title}</Heading>}
    {intro && <Note>{intro}</Note>}
    <img className={s.image} src={`/${src}`} alt={alt} />
    {list && <List items={list} />}
    {source && <Note>{`Source: ${fixRelativeLinks(source)}`}</Note>}
    {note && <Note>{`${fixRelativeLinks(note)}`}</Note>}
  </figure>
);

export const BlockQuote = ({ children }) => (
  <blockquote
    className={s.blockquote}
    dangerouslySetInnerHTML={{ __html: children }}
  />
);

export const Note = ({ children }) => (
  <p>
    <small className={s.note} dangerouslySetInnerHTML={{ __html: children }} />
  </p>
);

export const List = ({ items = [], id }) => (
  <ul className={s.list}>
    {items.map((item, i) => (
      <li
        key={i}
        id={id ? `${id}-${i + 1}` : ""}
        dangerouslySetInnerHTML={{ __html: fixRelativeLinks(item) }}
      />
    ))}
  </ul>
);

export const OrderedList = ({ items = [], id }) => (
  <ol className={s.orderedList}>
    {items.map((item, i) => (
      <li
        key={i}
        id={id ? `${id}-${i + 1}` : ""}
        dangerouslySetInnerHTML={{ __html: fixRelativeLinks(item) }}
      />
    ))}
  </ol>
);

export const ComponentPlaceholder = (props) => {
  if (process.env.NODE_ENV !== "development") return null;

  return (
    <div className={s.componentPlaceholder}>
      <div>
        <strong>Missing component</strong>
      </div>
      {props &&
        Object.entries(props).map(([key, value]) => (
          <div key={key}>
            <small>
              {key}: {Array.isArray(value) ? value.toString() : value}
            </small>
          </div>
        ))}
      <div></div>
    </div>
  );
};
